<template>
  <div class="item-inner">
    <div class="item-title label" v-if="attribute.sorteditAble === false" style="width: 60%; color: #8e8e93;" >模版来源合同</div>
    <div class="item-title label" v-else style="width: 60%;">
      模版来源合同
      <a class="alert-text" @click="displayMessage(attribute.description)" v-if="attribute.description">
        <img :src="questionUrl" style="width: .9rem"></img>
      </a>
    </div>
    <div class="item-input">
      <input type="text"  placeholder="请选择"  v-if="attribute.sorteditAble === false"  :value='attribute.value' disabled="disabled" >
      <input type="text"  @click="showOptionList(attribute)" placeholder="请选择"   v-else   v-model="attribute.value.split(':')[0]" readonly="readonly">
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import Emkt from '../../emkt'
  export default {
    name: 'attr-text-box',
    data () {
      return {
        checkedData: '',
        questionUrl: '/emktResources/resocurces/img/question.png',
        serarchOptions: [],
        serarchcustomerOptions: [],
        searchdata: ''
      }
    },
    props: [
      'attribute', 'index', 'curAttrsInGroup', 'attrGroups'
    ],
    mounted () {
    },
    created () {
      this.fetchData()
    },
    computed: {

    },
    methods: {
      fetchData () {
      },
      getAfterText (attribute) {
        this.attribute.options = Emkt.getLocalStorage('newContractNos')
        var ret1 = '<li class="item-content item-link"><label class="label-checkbox item-content">' +
          '<input type="radio" class="radio-input-attr"  name="attr" value="'
        var ret2 = ''
        var ret3 = '"><div class="item-media" style="margin-left: -1rem;"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">'
        var ret4 = '" checked="checked"><div class="item-media" style="margin-left: -1rem;"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">'
        var ret5 = '<div style="font-size: small">'
        var ret6 = '  <div class="searchbar row" id="showsearch"> <div class="search-input col-75" style="margin-left: 1.5rem;width: 60%"> <input  id="searchinput" placeholder="合同号／合同名称" /> </div> ' +
         '<a  class="button button-fill button-primary col-15" id="searchContract"><span class="icon icon-search"></span></a> </div>'
        var ret7 = '  <div class="searchbar row" id="showsearchcushomer"> <div class="search-input col-75" style="margin-left: 1.5rem;width: 60%"> <input  id="searchinput1" placeholder="客户编号" /> </div> ' +
          '<a  class="button button-fill button-primary col-15" id="searchcustomerContract"><span class="icon icon-search"></span></a> </div>'
        var ret8 = '  <div class="searchbar row" id="customerinput"> <div class="search-input col-75" style="margin-left: 1.5rem;width: 60%"> <input  id="yuancontract" placeholder="直接填写合同号" /> </div> ' +
          '<a  class="button button-fill button-primary col-15" id="customerContract" style="width: 15%"><span class="icon icon-button" >确定</span></a> </div>'
        let attr
        if (this.serarchOptions.length > 0 && this.searchdata !== '') {
          attr = this.serarchOptions
        } else if (this.serarchcustomerOptions.length > 0) {
          attr = this.serarchcustomerOptions
        } else {
          attr = this.attribute.options
        }
        let height = ''
        var length = 0
        for (var key in attr) {
          if (attribute.value === attr[key]) {
            ret2 += ret1 + key + ret4 + attr[key].split(':')[0] + ret5 + attr[key].split(':')[1] + '</div></div></div></label></li>'
          } else {
            ret2 += ret1 + key + ret3 + attr[key].split(':')[0] + ret5 + attr[key].split(':')[1] + '</div></div></div></label></li>'
          }
          length++
        }
        var ret
        if (length <= 7) {
          height = 2.1 * length + 1
          ret = ret8 + ret7 + ret6 + '<div class="modal-class" style="height: ' + height + 'rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">'
        } else {
          ret = ret8 + ret7 + ret6 + '<div class="modal-class" style="height: 12rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">'
        }
        ret = ret + ret2 + '</ul></div></div>'
        if (this.getTitle(attribute) === '您没有过历史定制合同，请全新定制!') {
          $('#showsearch').hide()
          return ret
        } else {
          return ret
        }
      },
      displayMessage (val) {
        if (!val) {
          return
        }
        $.alert(val)
      },
      getTitle (attribute) {
        if ((Emkt.getLocalStorage('newContractNos') && Emkt.getLocalStorage('newContractNos').length < 1) || Emkt.getLocalStorage('newContractNos') === undefined) {
          return '您没有过历史定制合同，请全新定制'
//          alert('您没有过历史定制合同，请全新定制！')
        } else {
          return attribute.label
        }
      },
      showOptionList (attribute) {
        let _this = this
        _this.attribute.options = []
//        $.showPreloader('正在查询')
//        setTimeout(function () {
//        }, 500)
        $.hidePreloader()
        $.modal({
          title: _this.getTitle(attribute),
          afterText: _this.getAfterText(attribute),
          buttons: [
            {
              text: '取消',
              bold: true,
              onClick: function () {
                if (_this.checkedData) {
                  _this.attribute.value = _this.checkedData
                  _this.attribute.valueText = _this.checkedData
                }
              }
            }
          ]
        })
        $('.radio-input-attr').on('click', function () {
          let val
          let radio = $('.radio-input-attr')
          if (_this.serarchOptions.length > 0 && _this.searchdata !== '') {
            for (var j = 0; j < radio.length; j++) {
              if (radio[j].checked) {
                val = _this.serarchOptions[radio[j].value]
              }
            }
          } else if (_this.serarchcustomerOptions.length > 0) {
            for (var k = 0; k < radio.length; k++) {
              if (radio[k].checked) {
                val = _this.serarchcustomerOptions[radio[k].value]
              }
            }
          } else {
            for (var i = 0; i < radio.length; i++) {
              if (radio[i].checked) {
                val = _this.attribute.options[radio[i].value]
              }
            }
          }
          if (_this.attribute.value !== val) {
            _this.attribute.value = val
            _this.attribute.valueText = val
            _this.checkedData = val
            if (_this.serarchcustomerOptions.length < 1) {
              _this.valueChanged(attribute)
            }
          }
          $.closeModal()
        })
        $('#searchcustomerContract').on('click', function () {
          _this.serarchcustomerOptions = []
          _this.serarchOptions = []
          let data = $('#searchinput1').val()
          console.log(data)
          _this.gcapi('searchContractNo', data).then(function (response) {
            _this.serarchcustomerOptions = response.body.result
            var contractNos = []
            var newContractNos = []
            contractNos = response.body.result
            if (_this.curAttrsInGroup[2].value === '3') {
              newContractNos = []
              for (var no1 in contractNos) {
                if (contractNos[no1].split(':')[0].indexOf('A') !== -1 && contractNos[no1].split(':')[0].indexOf('GVAP') === -1) {
                  newContractNos.push(contractNos[no1])
                }
              }
              _this.serarchcustomerOptions = newContractNos
            } else if (_this.curAttrsInGroup[2].value === '4') {
              newContractNos = []
              for (var no in contractNos) {
                if (contractNos[no].split(':')[0].indexOf('V') !== -1 && contractNos[no].split(':')[0].indexOf('GVAP') === -1) {
                  newContractNos.push(contractNos[no])
                }
              }
              _this.serarchcustomerOptions = newContractNos
            } else if (_this.curAttrsInGroup[2].value === '2') {
              newContractNos = []
              for (var no4 in contractNos) {
                if (contractNos[no4].indexOf('病毒') !== -1 || contractNos[no4].indexOf('质粒') !== -1 || contractNos[no4].indexOf('shRNA') !== -1 || contractNos[no4].split(':')[0].indexOf('GCI') !== -1) {
                  newContractNos.push(contractNos[no4])
                }
              }
              _this.serarchcustomerOptions = newContractNos
            } else if (_this.curAttrsInGroup[2].value === '1') {
              newContractNos = []
              for (var no2 in contractNos) {
                if (contractNos[no2].split(':')[0].indexOf('L') !== -1 || contractNos[no2].split(':')[0].indexOf('GCI') !== -1) {
                  newContractNos.push(contractNos[no2])
                }
              }
              _this.serarchcustomerOptions = newContractNos
            } else if (_this.curAttrsInGroup[2].value === '6') {
              newContractNos = []
              for (var no5 in contractNos) {
                if (contractNos[no5].split(':')[0].indexOf('R') !== -1) {
                  newContractNos.push(contractNos[no5])
                }
              }
              _this.serarchcustomerOptions = newContractNos
//                _this.gcapi('searchPreContract', 'GOSA66477').then(function (response) {
//                  if (response.body.result.labelNames !== undefined) {
//                    Emkt.setLocalStorage('target', response.body.result.labelNames)
//                  }
//                })
            } else if (_this.curAttrsInGroup[2].value === '7') {
              newContractNos = []
              for (var no6 in contractNos) {
                if (contractNos[no6].split(':')[0].indexOf('GOSL') !== -1 || (contractNos[no6].split(':')[0].indexOf('慢病毒') !== -1 && contractNos[no6].split(':')[0].indexOf('悬浮专用') !== -1)) {
                  newContractNos.push(contractNos[no6])
                }
              }
              _this.serarchcustomerOptions = newContractNos
//                _this.gcapi('searchPreContract', 'GOSA66477').then(function (response) {
//                  if (response.body.result.labelNames !== undefined) {
//                    Emkt.setLocalStorage('target', response.body.result.labelNames)
//                  }
//                })
            } else {
              _this.serarchcustomerOptions = contractNos
            }
            if (_this.serarchcustomerOptions.length < 1) {
              alert('此用户没有符合条件的合同，请您全新定制！')
            }
            _this.showOptionList(_this.attribute)
          })
        })
        $('#searchContract').on('click', function () {
          _this.serarchcustomerOptions = []
          _this.serarchOptions = []
          let data = $('#searchinput').val()
          _this.searchdata = data
          for (var i = 0; i < _this.attribute.options.length; i++) {
            if (_this.attribute.options[i].indexOf(data) !== -1) {
              _this.serarchOptions.push(_this.attribute.options[i])
            }
          }
          if (_this.serarchOptions.length < 1 && data !== '') {
            alert('查询结果无此合同号！')
          } else {
            _this.showOptionList(_this.attribute)
          }
        })
        $('#customerContract').on('click', function () {
          let data = $('#yuancontract').val().toString()
          if (!(data.replace(/^[a-zA-Z0-9]+$/g, '') === '')) {
            _this.attribute.value = ''
            _this.attribute.valueText = ''
            alert('请您填写数字和英文')
          } else {
            _this.attribute.value = data
            _this.attribute.valueText = data
          }
//            _this.$emit('controlForm', 4, _this.curAttrsInGroup, _this.attribute)
          $.hidePreloader()
        })
      },
      valueChanged (attribute) {
//        this.$emit('controlForm', this.index, this.curAttrsInGroup, attribute)
//        this.$emit('judgeValue', this.curAttrsInGroup, this.index)
      }
//      ,
//      getKeyByValue (value) {
//        let obj = this.attribute.options
//        for (var prop in obj) {
//          if (obj.hasOwnProperty(prop)) {
//            if (obj[prop] === value) {
//              return prop
//            }
//          }
//        }
//      }
    },
    watch: {
      'attribute.value': function (val) {
        this.attribute.options = []
        this.attribute.options.push(val)
        this.$emit('controlForm', this.index, this.curAttrsInGroup, val)
//        this.attribute.valueText = this.attribute.options[val]
      }
//      ,
//      attribute: {
//        handler: function (val) {
//          this.attribute.value = this.getKeyByValue(val)
//        },
//        deep: true
//      }
    }
  }
</script>

<style scoped>
  input {
    border: 1px solid #ccc;
    outline: 0;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  }
  .error input {
    border-color: rgba(246, 58, 56, .8);
    box-shadow: 0 0 8px rgba(246, 58, 56, .6);
  }
  .modal-class{
    width: 12rem;
    height: 15rem;
    margin-top: 1rem;
    margin-left: -3rem;
  }

</style>



// WEBPACK FOOTER //
// TemContractChoose.vue?e5b6db2c